import { Button } from "@inmagik/magik-ui"
import { Modal } from "react-bootstrap"

export default function ModalDelete({
  isOpen,
  onClose,
  onDelete,
  title,
  message,
}: {
  isOpen: boolean
  onClose: () => void
  onDelete: () => void
  title: string
  message: string
}) {
  return (
    <Modal show={isOpen} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer className="d-flex justify-content-between align-items-center">
        <Button title="Annulla" size="md" outline onClick={onClose} leadingIcon="close" />
        <Button variant="danger" size="md" title="Elimina" onClick={onDelete} leadingIcon="delete" />
      </Modal.Footer>
    </Modal>
  )
}
